import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseCargoClassify/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseCargoClassify',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseCargoClassify',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseCargoClassify/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseCargoClassify',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOption(params) {
  return request({
    url: '/api/base/baseCargoClassify/listOption',
    method: 'get',
    params
  })
}
